/* eslint-disable react/prop-types */ // TODO: upgrade to latest eslint tooling
/* eslint-disable react/display-name */ // TODO: upgrade to latest eslint tooling
import * as React from 'react';
import {
  colorDropbox,
  colorFacebook,
  colorInstagram,
  colorLinkedIn,
  colorMastercard,
  colorSpotify,
  colorTwitter,
  colorWhite,
  colorYouTube,
} from '../theme/color';
import { classes, style } from 'typestyle';

export interface SVGIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const DEFAULT_SIZE = 24;
const DEFAULT_COLOR = colorWhite.toString();

export const SVGIcon: SVGIconTypes = {
  About: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 29 29"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M14.5 13.036c-.807 0-1.464.657-1.464 1.464 0 .807.657 1.464 1.464 1.464.807 0 1.464-.657 1.464-1.464 0-.807-.657-1.464-1.464-1.464"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M14.5 1C7.056 1 1 7.056 1 14.5S7.056 28 14.5 28 28 21.944 28 14.5 21.944 1 14.5 1zm0 9.45a4.055 4.055 0 0 0-4.05 4.05 4.055 4.055 0 0 0 4.05 4.05 4.055 4.055 0 0 0 4.05-4.05 4.055 4.055 0 0 0-4.05-4.05z"
        />
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M23.382 14.498c-.187-4.894-3.984-8.882-8.882-8.882m-8.882 8.882c0 4.897 3.987 9.04 8.882 8.881"
        />
      </g>
    </svg>
  ),
  ArrowDown: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      fill={color}
      viewBox="0 6 24 12"
    >
      <path id="a" d="M4 9l8 8 8-8z" />
    </svg>
  ),
  ArrowLeft: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (17 / 29)}
      height={size}
      viewBox="0 0 17 29"
    >
      <g fill="none" fillRule="evenodd" stroke={color}>
        <path strokeWidth="2.7" d="M16 1L2 14.493l14 13.492" />
      </g>
    </svg>
  ),
  ArrowMore: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (16 / 12)}
      height={size}
      viewBox="0 0 16 12"
    >
      <g fill="none" fillRule="evenodd" stroke={color}>
        <path d="M9.375 0L15 6l-5.625 6" />
        <path strokeLinecap="square" d="M.625 6h13.792" />
      </g>
    </svg>
  ),
  ArrowRight: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (17 / 29)}
      height={size}
      viewBox="0 0 17 29"
    >
      <g fill="none" fillRule="evenodd" stroke={color}>
        <path strokeWidth="2.7" d="M1 1l14 13.493L1 27.985" />
      </g>
    </svg>
  ),
  ArrowUpRightBox: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      className={classes(styles.container, className)}
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
      />
      <path
        fillRule="evenodd"
        d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
      />
    </svg>
  ),
  ArrowUpRightBoxThick: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
    >
      <path
        id="a"
        d="M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
      />
    </svg>
  ),
  Basket: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (34 / 28)}
      height={size}
      viewBox="0 0 34 28"
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M1 8l4.352 19h21.93L32.59 8.037z"
        />
        <g stroke={color} strokeLinecap="round" strokeWidth="2">
          <path d="M6 7.197L11.685 1M26.685 7.197L21 1" />
        </g>
      </g>
    </svg>
  ),
  Book: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
    >
      <path
        stroke={color}
        d="M15.889 3.604c-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314 0-0.114-0.039-0.225-0.111-0.314-0.798-0.989-2.289-1.604-3.889-1.604s-3.091 0.615-3.889 1.604c-0.072 0.089-0.111 0.2-0.111 0.314v10c0 0.212 0.134 0.401 0.334 0.471s0.423 0.008 0.556-0.157c0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.097 0.12 0.241 0.186 0.389 0.186h1c0.148 0 0.292-0.066 0.389-0.186 0.613-0.76 1.805-1.232 3.111-1.232s2.498 0.472 3.111 1.232c0.133 0.165 0.356 0.228 0.556 0.157s0.334-0.26 0.334-0.471v-10c0-0.114-0.039-0.225-0.111-0.314zM7 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717zM15 12.822c-0.813-0.52-1.879-0.822-3-0.822s-2.187 0.301-3 0.822v-8.717c0.639-0.685 1.769-1.104 3-1.104s2.361 0.42 3 1.104v8.717z"
      />
    </svg>
  ),
  Browse: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (30 / 28)}
      height={size}
      viewBox="0 0 30 28"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
        <path d="M27.339 18.539c.662-1.563.807-2.668.807-4.47C28.146 6.863 22.282 1 15.073 1 7.863 1 2 6.863 2 14.07c0 1.377.214 2.705.611 3.953" />
        <path d="M3.654 17.953a3.21 3.21 0 0 0-2.155 3.99 3.21 3.21 0 0 0 3.991 2.153M10.591 25.736l-3.984 1.19-3.573-11.951 3.985-1.19zM24.036 24.096a3.21 3.21 0 0 0 3.991-2.153 3.21 3.21 0 0 0-2.154-3.99M18.935 25.736l3.985 1.19 3.573-11.951-3.985-1.19z" />
      </g>
    </svg>
  ),
  Checkmark: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <path fill={color} d="M432 64l-240 240-112-112-80 80 192 192 320-320z" />
    </svg>
  ),
  CheckmarkCircle: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill={color}
      className={classes(styles.container, className)}
      viewBox="0 0 16 16"
    >
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
    </svg>
  ),
  Copy: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M20 8v-8h-14l-6 6v18h12v8h20v-24h-12zM6 2.828v3.172h-3.172l3.172-3.172zM2 22v-14h6v-6h10v6l-6 6v8h-10zM18 10.828v3.172h-3.172l3.172-3.172zM30 30h-16v-14h6v-6h10v20z"
      />
    </svg>
  ),
  Copyright: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      viewBox="0 0 22 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
    >
      <defs>
        <path
          d="M18.5,2 C16.016,2 14,4.016 14,6.5 C14,8.984 16.016,11 18.5,11 C20.984,11 23,8.984 23,6.5 C23,4.016 20.984,2 18.5,2 Z"
          id="path-1"
        ></path>
        <filter x="-77.8%" y="-55.6%" width="255.6%" height="255.6%" filterUnits="objectBoundingBox" id="filter-2">
          <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
          <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icon---Non-Vouch-Claim-v2" transform="translate(-1.000000, 0.000000)">
          <g id="Group" transform="translate(-1.000000, -1.000000)">
            <circle id="Oval" fill="#FFFFFF" cx="11.5" cy="11.5" r="8.5"></circle>
            <g id="copyright-24px" fill="#4A00FF" fillRule="nonzero" opacity="0.8">
              <path
                d="M9.676,10.417 C9.7235,10.1035 9.828,9.828 9.961,9.5905 C10.094,9.353 10.284,9.1535 10.5215,9.0015 C10.7495,8.859 11.0345,8.7925 11.386,8.783 C11.6045,8.7925 11.804,8.8305 11.9845,8.9065 C12.1745,8.992 12.3455,9.106 12.4785,9.2485 C12.6115,9.391 12.716,9.562 12.8015,9.752 C12.887,9.942 12.925,10.151 12.9345,10.36 L14.635,10.36 C14.616,9.9135 14.5305,9.505 14.369,9.1345 C14.2075,8.764 13.989,8.441 13.704,8.175 C13.419,7.909 13.077,7.7 12.678,7.548 C12.279,7.396 11.842,7.3295 11.3575,7.3295 C10.74,7.3295 10.1985,7.434 9.7425,7.6525 C9.2865,7.871 8.9065,8.156 8.6025,8.5265 C8.2985,8.897 8.0705,9.3245 7.928,9.8185 C7.7855,10.3125 7.7,10.8255 7.7,11.3765 L7.7,11.633 C7.7,12.184 7.776,12.697 7.9185,13.191 C8.061,13.685 8.289,14.1125 8.593,14.4735 C8.897,14.8345 9.277,15.129 9.733,15.338 C10.189,15.547 10.7305,15.661 11.348,15.661 C11.7945,15.661 12.2125,15.585 12.602,15.4425 C12.9915,15.3 13.3335,15.1005 13.628,14.844 C13.9225,14.5875 14.16,14.293 14.331,13.951 C14.502,13.609 14.6065,13.248 14.616,12.8585 L12.9155,12.8585 C12.906,13.058 12.8585,13.2385 12.773,13.4095 C12.6875,13.5805 12.5735,13.723 12.431,13.8465 C12.2885,13.97 12.127,14.065 11.937,14.1315 C11.7565,14.198 11.5665,14.217 11.367,14.2265 C11.025,14.217 10.74,14.1505 10.5215,14.008 C10.284,13.856 10.094,13.6565 9.961,13.419 C9.828,13.1815 9.7235,12.8965 9.676,12.583 C9.6285,12.2695 9.6,11.9465 9.6,11.633 L9.6,11.3765 C9.6,11.044 9.6285,10.7305 9.676,10.417 L9.676,10.417 Z M11.5,2 C6.256,2 2,6.256 2,11.5 C2,16.744 6.256,21 11.5,21 C16.744,21 21,16.744 21,11.5 C21,6.256 16.744,2 11.5,2 Z M11.5,19.1 C7.3105,19.1 3.9,15.6895 3.9,11.5 C3.9,7.3105 7.3105,3.9 11.5,3.9 C15.6895,3.9 19.1,7.3105 19.1,11.5 C19.1,15.6895 15.6895,19.1 11.5,19.1 Z"
                id="Shape"
              ></path>
            </g>
            <g id="Path-Copy" fillRule="nonzero">
              <use fill="#4A00FF" href="#path-1"></use>
            </g>
            <polygon id="Path-Copy-2" fill="#FFFFFF" fillRule="nonzero" points="19 9 18 9 18 8 19 8"></polygon>
            <polygon id="Path-Copy-3" fill="#FFFFFF" fillRule="nonzero" points="19 7 18 7 18 4 19 4"></polygon>
          </g>
        </g>
      </g>
    </svg>
  ),
  Cross: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square" strokeWidth="2.7">
        <path d="M2.395 2.048l20.449 20.295M22.605 2.048L2.156 22.343" />
      </g>
    </svg>
  ),
  Dropbox: ({ className, size = DEFAULT_SIZE, color = colorDropbox.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M9.414 1.12l-9.414 6.14 6.508 5.212 9.492-5.856-6.586-5.5zM0 17.688l9.414 6.146 6.586-5.494-9.492-5.866-6.508 5.214zM16 18.34l6.586 5.496 9.414-6.146-6.508-5.214-9.492 5.86zM32 7.264l-9.414-6.144-6.586 5.494 9.492 5.86 6.508-5.21z"
      />
      <path
        fill={color}
        d="M16.020 19.52l-6.606 5.48-2.828-1.844v2.070l9.434 5.654 9.432-5.654v-2.070l-2.826 1.846-6.606-5.482z"
      />
    </svg>
  ),
  Facebook: ({ className, size = DEFAULT_SIZE, color = colorFacebook.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M30.234 0h-28.468c-0.976 0-1.766 0.79-1.766 1.766v28.468c0 0.976 0.79 1.766 1.766 1.766h15.326v-12.392h-4.172v-4.828h4.172v-3.566c0-4.132 2.524-6.38 6.212-6.38 1.766 0 3.284 0.128 3.726 0.188v4.32h-2.56c-2 0-2.39 0.96-2.39 2.36v3.080h4.78l-0.62 4.84h-4.16v12.378h8.154c0.976 0 1.766-0.79 1.766-1.766v-28.468c0-0.976-0.79-1.766-1.766-1.766z"
      />
    </svg>
  ),
  Fire: ({ className, size = DEFAULT_SIZE, color = colorFacebook.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
    >
      <path
        fill="#ff9d33"
        d="M57 26.2s-3 2.8-8.1 6.1C47.5 24.2 43.6 14.2 36 2c0 0-2.5 13.1-10.8 25.4-3.6-5.6-5.2-10-5.2-10C-6 43.5 15.6 62 29.2 62c17.4 0 32.7-8.4 27.8-35.8"
      />
      <path
        fill="#ffce31"
        d="M46.7 49.4c1.5-3.3 2.6-7.6 2.8-13 0 0-2.1 1.8-5.7 4.1-1-5.4-3.7-12-9-20.2 0 0-1.7 8.7-7.5 17-2.5-3.7-3.6-6.7-3.6-6.7-4.3 6.8-6 12.2-6.1 16.5-2.4-.9-3.9-1.6-3.9-1.6 4.1 12.2 12.6 14.9 16.4 14.9 6.8 0 13.7-2 20.5-11.7 0-.1-1.5.3-3.9.7"
      />
      <path
        fill="#ffdf85"
        d="M21.9 43.9s2.8 3.8 4.9 2.9c0 0 4-6.3 9.8-9.8 0 0-1.2 9.6.2 11.3 1.8 2.3 6.7-2.5 6.7-2.5 0 5.7-6.2 12.8-11.8 12.8-5.4 0-13.2-6.2-9.8-14.7"
      />
      <g fill="#ff9d33">
        <path d="M49.8 18.1c2.1-3 3.5-6.2 3.5-6.2 3.5 5.8 1.4 9.3-.1 10.4-2.1 1.6-5.8-.7-3.4-4.2M11.6 17.1c-2.1-3.5-2.3-7.9-2.3-7.9-5 7.5-3.1 11.7-1.4 12.9 2.2 1.7 6-.9 3.7-5M23.2 9.3c.3-2.4-.7-4.8-.7-4.8 4.7 3.1 4.7 5.7 4.1 6.8-.9 1.3-3.7.7-3.4-2" />
      </g>
    </svg>
  ),
  Filters: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <g stroke={color} fill="none" strokeWidth="48px">
        <path d="M142.49,256a56.25,56.25,0,1,1-56.24-56.25A56.25,56.25,0,0,1,142.49,256ZM256,32a56.25,56.25,0,1,0,56.25,56.25A56.25,56.25,0,0,0,256,32ZM426.75,367.51A56.25,56.25,0,1,0,483,423.75,56.24,56.24,0,0,0,426.75,367.51ZM256,144.49V512.08M426.75,480l-.5,31.3M86,312.25V512M426.75,0V367.51M85.75,0V199.75M256,0V32M142.49,256a56.25,56.25,0,1,1-56.24-56.25A56.25,56.25,0,0,1,142.49,256ZM256,32a56.25,56.25,0,1,0,56.25,56.25A56.25,56.25,0,0,0,256,32ZM426.75,367.51A56.25,56.25,0,1,0,483,423.75,56.24,56.24,0,0,0,426.75,367.51ZM256,144.49V512.08M426.75,480l-.5,31.3M86,312.25V512M426.75,0V367.51M85.75,0V199.75M256,0V32" />
      </g>
    </svg>
  ),
  FAQ: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M224 352h64v64h-64zM352 128c17.673 0 32 14.327 32 32v96l-96 64h-64v-32l96-64v-32h-160v-64h192zM256 48c-55.559 0-107.792 21.636-147.078 60.922s-60.922 91.519-60.922 147.078c0 55.559 21.636 107.792 60.922 147.078s91.519 60.922 147.078 60.922c55.559 0 107.792-21.636 147.078-60.922s60.922-91.519 60.922-147.078c0-55.559-21.636-107.792-60.922-147.078s-91.519-60.922-147.078-60.922zM256 0v0c141.385 0 256 114.615 256 256s-114.615 256-256 256c-141.385 0-256-114.615-256-256s114.615-256 256-256z"
      />
    </svg>
  ),
  Favourite: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={(size * 645) / 585}
      height={size}
      viewBox="-20 0 695 585"
    >
      <path
        strokeWidth="50"
        fill="none"
        stroke={color}
        d="M 297.29747,550.86823 C 283.52243,535.43191 249.1268,505.33855 220.86277,483.99412 C 137.11867,420.75228 125.72108,411.5999 91.719238,380.29088 C 29.03471,322.57071 2.413622,264.58086 2.5048478,185.95124 C 2.5493594,147.56739 5.1656152,132.77929 15.914734,110.15398 C 34.151433,71.768267 61.014996,43.244667 95.360052,25.799457 C 119.68545,13.443675 131.6827,7.9542046 172.30448,7.7296236 C 214.79777,7.4947896 223.74311,12.449347 248.73919,26.181459 C 279.1637,42.895777 310.47909,78.617167 316.95242,103.99205 L 320.95052,119.66445 L 330.81015,98.079942 C 386.52632,-23.892986 564.40851,-22.06811 626.31244,101.11153 C 645.95011,140.18758 648.10608,223.6247 630.69256,270.6244 C 607.97729,331.93377 565.31255,378.67493 466.68622,450.30098 C 402.0054,497.27462 328.80148,568.34684 323.70555,578.32901 C 317.79007,589.91654 323.42339,580.14491 297.29747,550.86823 z"
      />
    </svg>
  ),
  FavouriteDesktopCTA: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size - 1}
      viewBox="0 0 20 19"
    >
      <path
        fill={color}
        d="M14.5 0C17.58 0 20 2.42 20 5.5c0 2.144-1.094 4.062-2.98 6.175l-2.345-2.144C14.033 8.945 13 9.4 13 10.27l.001 5.357c-.497.456-1.014.926-1.551 1.414L10 18.35l-1.45-1.32C3.4 12.36 0 9.28 0 5.5 0 2.42 2.42 0 5.5 0 7.24 0 8.91.81 10 2.09 11.09.81 12.76 0 14.5 0zM14 10.27l2.342 2.139h-.001L19 14.841h-2.188l.382.655.41.726.29.527.216.41.187.373.078.166c.064.14-.115.364-.228.486l-.084.085h-.625l-1.563-2.857L14 17.126V10.27z"
      />
    </svg>
  ),
  FavouriteMobileCTA: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 26 26"
    >
      <path
        fill={color}
        d="M14.86 8.961l.046.138 1.06 3.698-.006.006.607 2.117.875-.25c.298-.086.606-.101.913-.044l4.494.834c.848.162 1.5.839 1.619 1.689l.623 4.46a1.994 1.994 0 01-1.429 2.2l-5.921 1.698c-.51.146-1.298.154-1.768-.107l-5.685-3.353.567-1.036a.99.99 0 01.807-.523l3.328-.184L12.03 9.98a1.515 1.515 0 01-.053-.285A1.495 1.495 0 0113.05 8.07c.751-.215 1.53.18 1.81.891zM14.5 0C17.58 0 20 2.42 20 5.5c0 2.238-1.192 4.23-3.233 6.455l-.9-3.132a2.498 2.498 0 00-3.092-1.714l-.157.05a2.498 2.498 0 00-1.557 3.042l1.636 5.704-1.247 1.135L10 18.35l-1.45-1.32C3.4 12.36 0 9.28 0 5.5 0 2.42 2.42 0 5.5 0 7.24 0 8.91.81 10 2.09 11.09.81 12.76 0 14.5 0z"
      />
    </svg>
  ),
  GenreBreakbeat: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M10.5,21 C11.3284271,21 12,20.3284271 12,19.5 C12,18.6715729 11.3284271,18 10.5,18 C9.67157288,18 9,18.6715729 9,19.5 C9,20.3284271 9.67157288,21 10.5,21 Z M10.4867475,16.5413813 L7.93506742,8.8863411 L11.1975485,5.15779126 L5.7763932,2.4472136 C5.52940395,2.32371897 5.42929178,2.02338245 5.5527864,1.7763932 C5.67628103,1.52940395 5.97661755,1.42929178 6.2236068,1.5527864 L12.8024515,4.84220874 L9.06493258,9.1136589 L9.16151849,9.40341664 L15.3949448,7.02877806 L14.0186745,2.13537279 C13.9439102,1.86954407 14.0987985,1.59343886 14.3646272,1.51867453 C14.6304559,1.4439102 14.9065611,1.59879849 14.9813255,1.86462721 L16.6050552,7.6378886 L9.47802842,10.3529464 L11.4743416,16.3418861 C11.4964463,16.4082002 11.5038835,16.475872 11.4984133,16.5413813 L14.7180423,16.5413813 L17.8518239,19.6447255 C18.0480365,19.8390324 18.0495815,20.1556112 17.8552745,20.3518239 C17.6609676,20.5480365 17.3443888,20.5495815 17.1481761,20.3552745 L14.3066845,17.5413813 L12.0538028,17.5413813 C12.6303238,17.9993575 13,18.7065075 13,19.5 C13,20.8807119 11.8807119,22 10.5,22 C9.11928813,22 8,20.8807119 8,19.5 C8,18.7065075 8.36967616,17.9993575 8.94619715,17.5413813 L5.5,17.5413813 L5.5,14 C5.5,13.7238576 5.72385763,13.5 6,13.5 C6.27614237,13.5 6.5,13.7238576 6.5,14 L6.5,16.5413813 L10.4867475,16.5413813 Z"
        />
      </g>
    </svg>
  ),
  GenreDrumAndBass: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M22.5,6.49974194 L1.5,6.48890043 L1.5,17 C1.5,18.292802 6.2265281,19.6435259 12,19.6435259 C17.7734719,19.6435259 22.5,18.292802 22.5,17 L22.5,6.49974194 Z"
        />
        <path
          fill={color}
          fillRule="nonzero"
          d="M2 9.13702405C2 9.98650654 6.52818845 11.28055 12 11.28055 17.4718116 11.28055 22 9.98650654 22 9.13702405L23 9.13702405C23 10.8731455 18.0751322 12.28055 12 12.28055 5.92486775 12.28055 1 10.8731455 1 9.13702405L2 9.13702405zM2 9.13702405C2 9.98650654 6.52818845 11.28055 12 11.28055 17.4718116 11.28055 22 9.98650654 22 9.13702405L23 9.13702405C23 10.8731455 18.0751322 12.28055 12 12.28055 5.92486775 12.28055 1 10.8731455 1 9.13702405L2 9.13702405zM12 8C17.4521304 8 22 6.75967192 22 6 22 5.24032808 17.4521304 4 12 4 6.54786964 4 2 5.24032808 2 6 2 6.75967192 6.54786964 8 12 8zM12 9C5.92486775 9 1 7.65685425 1 6 1 4.34314575 5.92486775 3 12 3 18.0751322 3 23 4.34314575 23 6 23 7.65685425 18.0751322 9 12 9z"
        />
        <path
          fill={color}
          fillRule="nonzero"
          d="M7.07580269,8.23529314 L6.94549525,7.97957269 L6.05450475,8.43359463 L6.49005564,9.28833683 L2.06292136,17.2571785 C1.92881477,17.4985704 2.01578667,17.802972 2.25717853,17.9370786 C2.4985704,18.0711852 2.80297205,17.9842133 2.93707864,17.7428215 L7.03734049,10.3623501 L11.5545047,19.227011 L12.4454953,18.772989 L7.62274175,9.30862786 L7.93707864,8.74282147 C8.07118523,8.5014296 7.98421333,8.19702795 7.74282147,8.06292136 C7.50887163,7.93294923 7.21573726,8.01063417 7.07580349,8.23529471 L6.94549525,7.97957269 L6.05450475,8.43359463 L11.5545047,19.227011 L12.4454953,18.772989 L7.07580339,8.2352945 Z M16.9370786,8.25717853 L21.9370786,17.2571785 C22.0711852,17.4985704 21.9842133,17.802972 21.7428215,17.9370786 C21.5014296,18.0711852 21.197028,17.9842133 21.0629214,17.7428215 L16.0629214,8.74282147 C15.9288148,8.5014296 16.0157867,8.19702795 16.2571785,8.06292136 C16.4985704,7.92881477 16.802972,8.01578667 16.9370786,8.25717853 Z"
        />
        <path
          fill={color}
          fillRule="nonzero"
          d="M17.0524491,8.23540234 L11.5524491,19.277069 C11.4293278,19.5242445 11.5298935,19.8244295 11.777069,19.9475509 C12.0242445,20.0706722 12.3244295,19.9701065 12.4475509,19.722931 L17.9475509,8.68126433 C18.0706722,8.43408881 17.9701065,8.13390386 17.722931,8.01078247 C17.4757555,7.88766109 17.1755705,7.98822682 17.0524491,8.23540234 Z"
        />
      </g>
    </svg>
  ),
  GenreDubstep: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          d="M6.56274601,20.3942277 C8.16599149,21.4353656 10.0393608,22 12,22 C13.9606392,22 15.8340085,21.4353656 17.437254,20.3942277 C17.5886959,19.2480653 18.5574792,18.3596989 19.7388227,18.3339096 C21.1900175,16.5638942 22,14.3462186 22,12 C22,9.65378136 21.1900175,7.4361058 19.7388227,5.66609038 C18.5574792,5.64030107 17.5886959,4.75193471 17.437254,3.60577233 C15.8340085,2.56463437 13.9606392,2 12,2 C10.0393608,2 8.16599149,2.56463437 6.56274601,3.60577233 C6.41130408,4.75193471 5.44252083,5.64030107 4.26117728,5.66609038 C2.80998248,7.4361058 2,9.65378136 2,12 C2,14.3462186 2.80998248,16.5638942 4.26117728,18.3339096 C5.44252083,18.3596989 6.41130408,19.2480653 6.56274601,20.3942277 Z M1,12 C1,9.1591868 2.07688283,6.56989307 3.84469753,4.61806976 C3.96052599,4.64975135 4.08245427,4.66666667 4.20833333,4.66666667 C4.96772486,4.66666667 5.58333333,4.0510582 5.58333333,3.29166667 C5.58333333,3.21846265 5.57761272,3.14659476 5.56659414,3.07648565 C7.37568396,1.76993707 9.59792776,1 12,1 C14.4020722,1 16.624316,1.76993707 18.4334059,3.07648565 C18.4223873,3.14659476 18.4166667,3.21846265 18.4166667,3.29166667 C18.4166667,4.0510582 19.0322751,4.66666667 19.7916667,4.66666667 C19.9175457,4.66666667 20.039474,4.64975135 20.1553025,4.61806976 C21.9231172,6.56989307 23,9.1591868 23,12 C23,14.8408132 21.9231172,17.4301069 20.1553025,19.3819302 C20.039474,19.3502486 19.9175457,19.3333333 19.7916667,19.3333333 C19.0322751,19.3333333 18.4166667,19.9489418 18.4166667,20.7083333 C18.4166667,20.7815373 18.4223873,20.8534052 18.4334059,20.9235143 C16.624316,22.2300629 14.4020722,23 12,23 C9.59792776,23 7.37568396,22.2300629 5.56659414,20.9235143 C5.57761272,20.8534052 5.58333333,20.7815373 5.58333333,20.7083333 C5.58333333,19.9489418 4.96772486,19.3333333 4.20833333,19.3333333 C4.08245427,19.3333333 3.96052599,19.3502486 3.84469753,19.3819302 C2.07688283,17.4301069 1,14.8408132 1,12 Z M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z M12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 Z M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
        />
      </g>
    </svg>
  ),
  GenreElectronic: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M24 3v18h-24v-18h24zm-7 13c2.208 0 4-1.792 4-4s-1.792-4-4-4-4 1.792-4 4c0 .728.195 1.412.536 2h-3.072c.341-.588.536-1.272.536-2 0-2.208-1.792-4-4-4s-4 1.792-4 4 1.792 4 4 4h10zm-10-6c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2zm10 0c1.104 0 2 .896 2 2s-.896 2-2 2-2-.896-2-2 .896-2 2-2z"
      />
    </svg>
  ),
  GenreFolk: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M7.62154122,9.62491768 C6.10396579,9.5605883 4.67677,10.0897932 3.63483526,11.131728 C1.49913971,13.2674235 1.63401599,16.9090833 3.98838865,19.263456 C6.34276131,21.6178286 9.98442108,21.7527049 12.1201166,19.6170094 C13.1620514,18.5750746 13.6912563,17.1478788 13.6269269,15.6303034 L13.6036994,15.0823494 L14.0532755,14.7682247 C14.2452686,14.6340766 14.4263663,14.4823325 14.5949904,14.3137085 C16.1570875,12.7516113 16.1570875,10.2189514 14.5949904,8.65685425 C13.0328932,7.09475708 10.5002333,7.09475708 8.93813612,8.65685425 C8.76951209,8.82547828 8.61776803,9.00657603 8.48361994,9.1985691 L8.16949517,9.64814522 L7.62154122,9.62491768 Z M17.7489438,4.68062233 L17.4141554,4.37708049 C17.20958,4.19159862 17.1941016,3.87539474 17.3795835,3.67081936 C17.5650654,3.46624398 17.8812693,3.45076564 18.0858446,3.63624751 L20.8358446,6.12958351 C21.04042,6.31506538 21.0558984,6.63126926 20.8704165,6.83584464 C20.6849346,7.04042002 20.3687307,7.05589836 20.1641554,6.87041649 L19.5370594,6.30184885 C19.5212638,6.32265953 19.503628,6.3424996 19.4841568,6.36114335 L16.3457969,9.36614135 C16.3345268,9.37693256 16.3228829,9.38709207 16.3109091,9.39662084 C17.159264,11.2429909 16.8229934,13.4999191 15.3020971,15.0208153 C15.0900169,15.2328955 14.8636248,15.421941 14.6260297,15.5879519 C14.699785,17.3278903 14.1053452,19.0459944 12.8272234,20.3241161 C10.2888155,22.862524 6.01495191,22.7042328 3.28128187,19.9705627 C0.547611827,17.2368927 0.389320583,12.9630291 2.92772848,10.4246212 C4.20585025,9.14649943 5.92395429,8.55205965 7.66389277,8.62581491 C7.82990361,8.3882198 8.01894913,8.16182767 8.23102934,7.94974747 C10.0229669,6.15780989 12.8366513,6.01034891 14.7967507,7.50736451 L17.7489438,4.68062233 Z M18.49155,5.35391934 C18.4891157,5.35634667 18.4866513,5.35875483 18.4841568,5.36114335 L15.5284082,8.19128992 C15.6204786,8.29622885 15.7074142,8.40410131 15.7892149,8.51458009 L18.792563,5.63885665 C18.7947179,5.63679339 18.7968864,5.63475322 18.7990682,5.63273614 L18.49155,5.35391934 Z M22.8358446,4.12958351 C23.04042,4.31506538 23.0558984,4.63126926 22.8704165,4.83584464 C22.6849346,5.04042002 22.3687307,5.05589836 22.1641554,4.87041649 L19.4141554,2.37708049 C19.20958,2.19159862 19.1941016,1.87539474 19.3795835,1.67081936 C19.5650654,1.46624398 19.8812693,1.45076564 20.0858446,1.63624751 L22.8358446,4.12958351 Z M21.8358446,5.12958351 C22.04042,5.31506538 22.0558984,5.63126926 21.8704165,5.83584464 C21.6849346,6.04042002 21.3687307,6.05589836 21.1641554,5.87041649 L18.4141554,3.37708049 C18.20958,3.19159862 18.1941016,2.87539474 18.3795835,2.67081936 C18.5650654,2.46624398 18.8812693,2.45076564 19.0858446,2.63624751 L21.8358446,5.12958351 Z M10.5,14 C11.3284271,14 12,13.3284271 12,12.5 C12,11.6715729 11.3284271,11 10.5,11 C9.67157288,11 9,11.6715729 9,12.5 C9,13.3284271 9.67157288,14 10.5,14 Z M10.5,15 C9.11928813,15 8,13.8807119 8,12.5 C8,11.1192881 9.11928813,10 10.5,10 C11.8807119,10 13,11.1192881 13,12.5 C13,13.8807119 11.8807119,15 10.5,15 Z"
        />
      </g>
    </svg>
  ),
  GenreHipHop: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (57 / 58)}
      height={size}
      viewBox="0 0 57 58"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-618.000000, -271.000000)" fill={color}>
          <g transform="translate(618.000000, 271.000000)">
            <g transform="translate(0.000000, 0.056812)">
              <path d="M52.5 52.57a.808.808 0 0 1-.807.806H4.557a.806.806 0 0 1-.806-.807V20.34c0-.436.36-.788.806-.788h47.136c.446 0 .808.352.808.787V52.57zM13.127 4.99c0-.234.19-.424.422-.424h29.154c.233 0 .424.19.424.424v10.81h-30V4.99zm38.567 10.81h-4.817V4.99A4.177 4.177 0 0 0 42.702.817H13.548a4.177 4.177 0 0 0-4.172 4.174v10.81H4.557c-2.512 0-4.556 2.034-4.556 4.537V52.57a4.561 4.561 0 0 0 4.556 4.557h47.136a4.563 4.563 0 0 0 4.558-4.557V20.34c0-2.504-2.046-4.538-4.558-4.538z" />
            </g>
            <path d="M20.625 27.107h15a1.873 1.873 0 0 0 1.875-1.875 1.873 1.873 0 0 0-1.875-1.875h-15a1.874 1.874 0 1 0 0 3.75" />
            <path d="M16.875 45.893a5.632 5.632 0 0 1-5.625-5.625 5.632 5.632 0 0 1 5.625-5.625 5.632 5.632 0 0 1 5.625 5.625 5.632 5.632 0 0 1-5.625 5.625m0-15c-5.17 0-9.375 4.206-9.375 9.375 0 5.17 4.206 9.375 9.375 9.375 5.17 0 9.375-4.205 9.375-9.375 0-5.169-4.206-9.375-9.375-9.375" />
            <path d="M39.376 45.893a5.633 5.633 0 0 1-5.627-5.625 5.633 5.633 0 0 1 5.627-5.625A5.632 5.632 0 0 1 45 40.268a5.632 5.632 0 0 1-5.625 5.625m0-15c-5.17 0-9.375 4.206-9.375 9.375 0 5.17 4.206 9.375 9.375 9.375 5.17 0 9.375-4.205 9.375-9.375 0-5.169-4.206-9.375-9.375-9.375" />
          </g>
        </g>
      </g>
    </svg>
  ),
  GenreHouse: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <path d="M4,8.87851192 L1.27540106,10.6765593 C1.04492273,10.8286591 0.734781869,10.7651208 0.582682066,10.5346424 C0.430582262,10.3041641 0.494120613,9.99402326 0.724598944,9.84192346 L11.7245989,2.58268207 C11.8916509,2.47243931 12.1083491,2.47243931 12.2754011,2.58268207 L23.2754011,9.84192346 C23.5058794,9.99402326 23.5694177,10.3041641 23.4173179,10.5346424 C23.2652181,10.7651208 22.9550773,10.8286591 22.7245989,10.6765593 L20,8.87851192 L20,21.009996 C20,21.2861384 19.7761424,21.509996 19.5,21.509996 C19.2238576,21.509996 19,21.2861384 19,21.009996 L19,8.5 C19,8.41272995 19.0223582,8.33068193 19.0616589,8.25927152 L12,3.59906364 L4.93834108,8.25927152 C4.97764183,8.33068193 5,8.41272995 5,8.5 L5,21.009996 C5,21.2861384 4.77614237,21.509996 4.5,21.509996 C4.22385763,21.509996 4,21.2861384 4,21.009996 L4,8.87851192 Z M13.2176768,8.86023472 C12.9897674,8.70431191 12.9314107,8.39315443 13.0873336,8.16524505 C13.2432564,7.93733566 13.5544138,7.87897902 13.7823232,8.03490184 L16.7823232,10.0873336 C17.0102326,10.2432564 17.0685893,10.5544138 16.9126664,10.7823232 C16.7567436,11.0102326 16.4455862,11.0685893 16.2176768,10.9126664 L13.2176768,8.86023472 Z M11,14 C12.6542632,14 14,15.3457368 14,17 C14,18.6542632 12.6542632,20 11,20 C9.34573684,20 8,18.6542632 8,17 C8,15.3457368 9.34573684,14 11,14 Z M11,15 C9.89802159,15 9,15.8980216 9,17 C9,18.1019784 9.89802159,19 11,19 C12.1019784,19 13,18.1019784 13,17 C13,15.8980216 12.1019784,15 11,15 Z" />
          <path d="M13,8.44756828 L13,16.5 C13,16.7761424 13.2238576,17 13.5,17 C13.7761424,17 14,16.7761424 14,16.5 L14,8.44756828 C14,8.1714259 13.7761424,7.94756828 13.5,7.94756828 C13.2238576,7.94756828 13,8.1714259 13,8.44756828 Z" />
        </g>
      </g>
    </svg>
  ),
  GenreIndie: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M1,17.5 L22.9540022,17.5 C22.9791059,14.7244953 21.590966,13.5 18.5,13.5 L16.5,13.5 C14.9652751,13.5 10.6621015,9.40708061 8.44665538,6 L1,6 L1,17.5 Z M16.2584012,12.4487056 C16.3527106,12.4824666 16.4337931,12.5 16.5,12.5 L18.5,12.5 C22.5,12.5 24.2991035,14.5 23.8973105,18.5 L0,18.5 L0,5 L9,5 C9.38516917,5.64001121 9.84682039,6.29674138 10.3502178,6.9426754 L10.6464466,6.64644661 C10.8417088,6.45118446 11.1582912,6.45118446 11.3535534,6.64644661 C11.5488155,6.84170876 11.5488155,7.15829124 11.3535534,7.35355339 L10.9831312,7.72397563 C11.0722672,7.83004153 11.1621796,7.93548916 11.2527044,8.04018883 L11.6464466,7.64644661 C11.8417088,7.45118446 12.1582912,7.45118446 12.3535534,7.64644661 C12.5488155,7.84170876 12.5488155,8.15829124 12.3535534,8.35355339 L11.9199975,8.78710928 C12.0141631,8.88918637 12.1085516,8.99016303 12.2029906,9.08990259 L12.6464466,8.64644661 C12.8417088,8.45118446 13.1582912,8.45118446 13.3535534,8.64644661 C13.5488155,8.84170876 13.5488155,9.15829124 13.3535534,9.35355339 L12.901975,9.80513177 C13.0012131,9.90347066 13.1000284,10.0000402 13.1982156,10.0946776 L13.6464466,9.64644661 C13.8417088,9.45118446 14.1582912,9.45118446 14.3535534,9.64644661 C14.5488155,9.84170876 14.5488155,10.1582912 14.3535534,10.3535534 L13.931129,10.7759778 C14.0366417,10.8703383 14.140695,10.9617225 14.2429953,11.0498979 L14.6464466,10.6464466 C14.8417088,10.4511845 15.1582912,10.4511845 15.3535534,10.6464466 C15.5488155,10.8417088 15.5488155,11.1582912 15.3535534,11.3535534 L15.0219697,11.6851371 C15.1389111,11.7744023 15.2516395,11.8573108 15.3595275,11.9333658 L15.6464466,11.6464466 C15.8417088,11.4511845 16.1582912,11.4511845 16.3535534,11.6464466 C16.5488155,11.8417088 16.5488155,12.1582912 16.3535534,12.3535534 L16.2584012,12.4487056 Z M5.5,13 C6.32842712,13 7,12.3284271 7,11.5 C7,10.6715729 6.32842712,10 5.5,10 C4.67157288,10 4,10.6715729 4,11.5 C4,12.3284271 4.67157288,13 5.5,13 Z M17.490098,16 L18.1077677,12.9116516 L19.0883484,13.1077677 L18.509902,16 L23,16 L23,17 L1,17 L1,16 L17.490098,16 Z M5.5,14 C4.11928813,14 3,12.8807119 3,11.5 C3,10.1192881 4.11928813,9 5.5,9 C6.88071187,9 8,10.1192881 8,11.5 C8,12.8807119 6.88071187,14 5.5,14 Z"
        />
      </g>
    </svg>
  ),
  GenrePop: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M19.1203546,10.2715723 C20.5668544,8.82507248 20.5668544,6.47983293 19.1203546,5.03333314 C17.6738548,3.58683334 15.3286152,3.58683334 13.8821154,5.03333314 C13.4760691,5.43937951 13.1262186,6.2503665 12.8787612,7.46154921 L16.7222525,11.27419 C17.9177734,11.0224428 18.7188235,10.6731033 19.1203546,10.2715723 Z M11.5579756,9.85086881 L14.5434928,12.836386 L15.7694446,11.7375793 L12.6425364,8.63576979 L11.5579756,9.85086881 Z M10.8910071,10.5981139 L3.02913915,19.4062399 L5.00686075,21.3839615 L13.7977131,13.5048199 L10.8910071,10.5981139 Z M11.9316,7.93053991 L11.799526,7.79952599 C12.0792335,6.12127378 12.5377278,4.96350724 13.1750086,4.32622635 C15.0120327,2.48920226 17.9904373,2.48920226 19.8274614,4.32622635 C21.6644854,6.16325044 21.6644854,9.14165497 19.8274614,10.9786791 C19.2266555,11.5794849 18.1593936,12.0242691 16.6256756,12.3130316 L4.96924461,22.7605589 L1.65392561,19.4452399 L11.9316,7.93053991 Z"
        />
      </g>
    </svg>
  ),
  GenrePunk: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill={color}
          fillRule="nonzero"
          d="M3.5,19 C2.67373212,19 2,19.6737321 2,20.5 C2,21.3262679 2.67373212,22 3.5,22 C4.32626788,22 5,21.3262679 5,20.5 C5,19.6737321 4.32626788,19 3.5,19 Z M2,18.5011512 C2.41810554,18.1866067 2.93766186,18 3.5,18 C4.85622122,18 5.96359949,19.0854086 5.99912083,20.4332118 L17.1799078,11.1158894 C17.3920462,10.9391073 17.7073286,10.9677694 17.8841106,11.1799078 C18.0608927,11.3920462 18.0322306,11.7073286 17.8200922,11.8841106 L5.8200922,21.8841106 C5.72622481,21.9623335 5.61216288,22.0003324 5.49884088,22.0000105 C5.04228987,22.6068704 4.31620978,23 3.5,23 C2.12144737,23 1,21.8785526 1,20.5 C1,20.3848053 1.00783064,20.2714058 1.02298759,20.160306 C1.00805273,20.1128639 1,20.0623703 1,20.009996 L1,4.5 C1,4.22385763 1.22385763,4 1.5,4 C1.77614237,4 2,4.22385763 2,4.5 L2,18.5011512 Z M18.2740934,10.9987367 L20.9111429,8.36055625 C21.6184785,7.65430811 22.026295,6.70271106 21.9986823,5.72455086 C21.9986823,3.6854687 20.3408915,2 18.2741315,2 C17.268375,2 16.3444014,2.3802038 15.6370657,3.08753949 L13,5.72460523 L13.6520887,6.37669391 C13.89635,6.62095528 14.2223944,6.75689771 14.5760622,6.75689771 C15.0114858,6.75689771 15.4193186,6.51263634 15.6359782,6.15790815 C15.6901431,6.02196572 15.7177557,5.94124854 15.7177557,5.91363591 L15.7177557,5.4251023 C15.8536982,4.12092494 16.9677736,3.14170439 18.2730385,3.14170439 C19.7142458,3.14170439 20.8559448,4.31102685 20.8559448,5.72461067 C20.8559448,7.02878802 19.8778118,8.11633838 18.5725469,8.27989345 L18.0840024,8.27989345 C18.0574501,8.27989345 17.9756726,8.27989345 17.8397302,8.36167098 C17.5136858,8.55177288 17.2959659,8.87890476 17.2418009,9.25910856 C17.2141774,9.66693587 17.3224964,10.0471397 17.6220048,10.3466481 L18.2740934,10.9987367 Z M18.5029119,7.27989345 C19.2854178,7.15583652 19.8559448,6.50103738 19.8559448,5.72461067 C19.8559448,4.85208622 19.1507927,4.14170439 18.2730385,4.14170439 C17.486122,4.14170439 16.8203556,4.72019894 16.7177557,5.48359992 L16.7177557,5.91363591 C16.7177557,6.13244539 16.6915089,6.21042259 16.5649538,6.52804918 L16.4893871,6.67915019 C16.088398,7.33567379 15.3552225,7.75689771 14.5760622,7.75689771 C13.9591694,7.75689771 13.3781833,7.51700213 12.9449819,7.08380069 L11.5857864,5.72460523 L14.929959,2.38043271 C15.8247436,1.48564807 17.0030231,1 18.2741315,1 C20.8848003,1 22.9986823,3.12475241 22.9982841,5.69633295 C23.0334786,6.94307302 22.5254917,8.16181634 21.6184012,9.06751141 L18.2742451,12.4131019 L16.914898,11.0537548 C16.4144463,10.5533032 16.1962524,9.89774981 16.2517969,9.1180698 C16.3488577,8.43676368 16.7445888,7.84263541 17.3242518,7.50476837 C17.5946309,7.34211912 17.8427268,7.27989345 18.0840024,7.27989345 L18.5029119,7.27989345 Z"
        />
      </g>
    </svg>
  ),
  GenreRemixes: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <path d="M21,4 C21.5522847,4 22,3.55228475 22,3 C22,2.44771525 21.5522847,2 21,2 C20.4477153,2 20,2.44771525 20,3 C20,3.55228475 20.4477153,4 21,4 Z M21,5 C19.8954305,5 19,4.1045695 19,3 C19,1.8954305 19.8954305,1 21,1 C22.1045695,1 23,1.8954305 23,3 C23,4.1045695 22.1045695,5 21,5 Z M3,22 C2.44771525,22 2,21.5522847 2,21 C2,20.4477153 2.44771525,20 3,20 C3.55228475,20 4,20.4477153 4,21 C4,21.5522847 3.55228475,22 3,22 Z M12,13 C12.5522847,13 13,12.5522847 13,12 C13,11.4477153 12.5522847,11 12,11 C11.4477153,11 11,11.4477153 11,12 C11,12.5522847 11.4477153,13 12,13 Z M12,14 C10.8954305,14 10,13.1045695 10,12 C10,10.8954305 10.8954305,10 12,10 C13.1045695,10 14,10.8954305 14,12 C14,13.1045695 13.1045695,14 12,14 Z M12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 Z M12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 Z" />
          <path d="M20.0517964,4.27872127 L16.0517964,12.3787213 C15.929526,12.6263188 16.0311237,12.9261561 16.2787213,13.0484265 C16.5263188,13.1706969 16.8261561,13.0690992 16.9484265,12.8215016 L20.9484265,4.72150158 C21.0706969,4.47390401 20.9690992,4.17406677 20.7215016,4.05179636 C20.473904,3.92952595 20.1740668,4.03112369 20.0517964,4.27872127 Z" />
        </g>
      </g>
    </svg>
  ),
  GenreRock: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={color}>
          <path
            d="M19.500026,7.18255027 L19.5001664,5.51290028 C19.4476525,3.47819969 18.1899672,2.5 15.5,2.5 L7,2.5 C4.60947571,2.5 3.5,3.60947571 3.5,6 L3.5,19.5 C3.5,20.6045695 4.3954305,21.5 5.5,21.5 C6.6045695,21.5 7.5,20.6045695 7.5,19.5 L7.5,13.1911814 L19.500026,7.18255027 Z"
            transform="matrix(1 0 0 -1 0 24)"
          />
          <path
            d="M19.5,10.1433981 L15.5,3.74339811 L15.5,15.5 C15.5,16.6045695 16.3954305,17.5 17.5,17.5 C18.6045695,17.5 19.5,16.6045695 19.5,15.5 L19.5,10.1433981 Z"
            transform="rotate(180 17.5 10)"
          />
          <path
            d="M19.4025291,13.5029146 L15.4382538,10.1049643 L15.3023485,17.4054581 C15.3020664,17.4236406 15.3020664,17.4236406 15.30201,17.4418253 C15.30201,18.5209308 16.1767978,19.3957187 17.2559034,19.3957187 L17.3126363,19.3957187 C18.399321,19.3957187 19.2871695,18.5280183 19.3121095,17.4416199 L19.4025291,13.5029146 Z"
            transform="scale(1 -1) rotate(45 52.277 0)"
          />
          <path
            d="M11.5,6.5 L7.5,6.5 L7.5,10 C7.5,11.1045695 8.3954305,12 9.5,12 C10.6045695,12 11.5,11.1045695 11.5,10 L11.5,6.5 Z"
            transform="rotate(180 9.5 9.25)"
          />
          <path
            d="M15.5,7.04031242 L11.5130655,10.22986 C11.6270701,11.2261688 12.4731661,12 13.5,12 C14.6045695,12 15.5,11.1045695 15.5,10 L15.5,7.04031242 Z"
            transform="rotate(180 13.5 9.25)"
          />
        </g>
      </g>
    </svg>
  ),
  Google: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M16.319 13.713v5.487h9.075c-0.369 2.356-2.744 6.9-9.075 6.9-5.463 0-9.919-4.525-9.919-10.1s4.456-10.1 9.919-10.1c3.106 0 5.188 1.325 6.375 2.469l4.344-4.181c-2.788-2.612-6.4-4.188-10.719-4.188-8.844 0-16 7.156-16 16s7.156 16 16 16c9.231 0 15.363-6.494 15.363-15.631 0-1.050-0.113-1.85-0.25-2.65l-15.113-0.006z"
      />
    </svg>
  ),
  GoogleMultiColour: ({ className, size = DEFAULT_SIZE }) => (
    <svg
      className={classes(styles.container, className)}
      width={size}
      height={size}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M386 400c45-42 65-112 53-179H260v74h102c-4 24-18 44-38 57l62 48z" fill="#4285f4" />
      <path d="M90 341a192 192 0 00296 59l-62-48c-53 35-141 22-171-60l-63 49z" fill="#34a853" />
      <path d="M153 292c-8-25-8-48 0-73l-63-49c-23 46-30 111 0 171l63-49z" fill="#fbbc02" />
      <path d="M153 219c22-69 116-109 179-50l55-54c-78-75-230-72-297 55l63 49z" fill="#ea4335" />
    </svg>
  ),
  HookIt: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (62 / 35)}
      height={size}
      viewBox="0 0 500 267.47"
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M0 25l12.59 242.47 487.41-25L487.41 0zm485.58 204.45l-460 23.6L14.42 38l460-23.6zM50.81 71.14l26.28-1.38 6.43 122.62 41.34-2.17 1.19 22.61-67.62 3.55zm82.6-4.33l26.48-1.39 7.61 145.23L141 212zM182 175.17l-4-76.38c-1.22-23.22 15.8-37.39 38.62-38.59 21.38-1.12 38.33 10.45 39.46 32l1 19.15-23.83 1.25-.87-16.7c-.44-8.35-6-13.37-14.57-12.92-9.57.5-13.54 6.63-13.09 15.18l3.89 74.14c.51 9.78 5.88 14.81 14.84 14.34 8.35-.44 13.36-6.21 12.93-14.36l-.86-16.5 23.83-1.25.94 17.93c1.15 22-14 36.27-36 37.42-23.45 1.27-41.01-10.27-42.29-34.71zm87.77-115.51l26.48-1.38 3.44 65.58 26.1-67.13 25.86-1.36-23.31 57.8 31.54 87.4-28.11 1.43-21.61-65.45-8.82 18.84 2.52 48.07-26.48 1.39zm133.48-6.72l-40.53 2.13 7.61 145.22 40.33-2.11c21.79-1.14 38.1-13.44 36.81-38.08l-3.94-75.16c-1.21-23.02-18.69-33.13-40.28-32zm17.46 107.13c.37 7.13-2.89 15.06-13.48 15.62l-11.81.62-5.26-100.22 11.61-.6c10-.53 14.79 5.35 15.21 13.5z"
      />
    </svg>
  ),
  InfoCircle: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <path
        fill={color}
        fillRule="evenodd"
        transform="translate(-2 -2)"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </svg>
  ),
  Instagram: ({ className, size = DEFAULT_SIZE, color = colorInstagram.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
      />
    </svg>
  ),
  LinkedIn: ({ className, size = DEFAULT_SIZE, color = colorLinkedIn.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      />
    </svg>
  ),
  MasterCard: ({ className, size = DEFAULT_SIZE, color = colorMastercard.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M15.124 24.040c0.076 0.066 0.16 0.13 0.24 0.196-1.568 1.044-3.452 1.652-5.476 1.652-5.46 0-9.888-4.428-9.888-9.888s4.428-9.888 9.888-9.888c2.024 0 3.908 0.608 5.474 1.652-0.080 0.066-0.16 0.13-0.22 0.2-2.342 2.020-3.682 4.952-3.682 8.036 0 3.080 1.334 6.012 3.664 8.040zM22.112 6.112c-2.026 0-3.908 0.608-5.474 1.652 0.080 0.066 0.16 0.13 0.22 0.2 2.342 2.020 3.682 4.952 3.682 8.036 0 3.080-1.334 6.010-3.664 8.040-0.076 0.066-0.16 0.13-0.24 0.196 1.568 1.044 3.45 1.652 5.476 1.652 5.46 0 9.888-4.428 9.888-9.888s-4.428-9.888-9.888-9.888zM16 8.232c-0.128 0.1-0.252 0.2-0.374 0.308-2.084 1.812-3.4 4.48-3.4 7.46s1.316 5.648 3.4 7.46c0.12 0.106 0.246 0.21 0.374 0.31 0.128-0.1 0.252-0.204 0.374-0.31 2.084-1.812 3.4-4.48 3.4-7.46s-1.316-5.648-3.4-7.46c-0.12-0.108-0.246-0.21-0.374-0.31z"
      />
    </svg>
  ),
  Menu: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <g fill="none" stroke={color} strokeLinecap="square" strokeWidth="48px">
        <path d="M512.4,255.7H0.3 M512.4,85.7H0.4 M512.4,426.4H0.4" />
      </g>
    </svg>
  ),
  Next: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (12 / 21)}
      height={size}
      viewBox="0 0 12 21"
    >
      <g fill={color} fillRule="evenodd">
        <path d="M10.883 10.183l-10.366 9.7V.483z" />
        <path d="M11.5 20.5V.5h-3v20z" />
      </g>
    </svg>
  ),
  NewTab: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
    >
      <g fill={color}>
        <path d="M11 13h-8v-8h4.5l2-2h-8.5v12h12v-8.5l-2 2v4.5z" />
        <path d="M16 0h-6.5l2.5 2.5-7.5 7.5 1.5 1.5 7.5-7.5 2.5 2.5v-6.5z" />
      </g>
    </svg>
  ),
  Pause: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (19 / 26)}
      height={size}
      viewBox="0 0 19 26"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="square" strokeWidth="6">
        <path d="M3 3.417V22.6M16 3.417V22.6" />
      </g>
    </svg>
  ),
  Play: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (20 / 24)}
      height={size}
      viewBox="0 0 20 24"
    >
      <path fill={color} fillRule="evenodd" d="M19.406 11.953L.148 23.87V.037z" />
    </svg>
  ),
  PlatformDailymotion: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M14.068 11.313c-1.754 0-3.104 1.427-3.104 3.11 0 1.753 1.35 3.085 3.255 3.085l-.016.002c1.59 0 2.925-1.31 2.925-3.04 0-1.8-1.336-3.157-3.062-3.157z"
      />
      <path
        fill={color}
        d="M0 0v24h24V0H0zm20.693 20.807h-3.576v-1.41c-1.1 1.08-2.223 1.47-3.715 1.47-1.522 0-2.832-.495-3.93-1.485-1.448-1.275-2.198-2.97-2.198-4.936 0-1.8.7-3.414 2.01-4.674 1.17-1.146 2.595-1.73 4.185-1.73 1.52 0 2.69.513 3.53 1.59V4.157l3.693-.765V3.39l.002.003h-.002v17.414z"
      />
    </svg>
  ),
  PlatformFacebook: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"
      />
    </svg>
  ),
  PlatformInstagram: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
      />
    </svg>
  ),
  PlatformLinkedIn: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
      />
    </svg>
  ),
  PlatformSnapchat: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z"
      />
    </svg>
  ),
  PlatformTwitch: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M2.089 0L.525 4.175v16.694h5.736V24h3.132l3.127-3.132h4.695l6.26-6.258V0H2.089zm2.086 2.085H21.39v11.479l-3.652 3.652H12l-3.127 3.127v-3.127H4.175V2.085z"
      />
      <path fill={color} d="M9.915 12.522H12v-6.26H9.915v6.26zm5.735 0h2.086v-6.26H15.65v6.26z" />
    </svg>
  ),
  PlatformTwitter: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"
      />
    </svg>
  ),
  PlatformVimeo: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M23.977 6.416c-.105 2.338-1.739 5.543-4.894 9.609-3.268 4.247-6.026 6.37-8.29 6.37-1.409 0-2.578-1.294-3.553-3.881L5.322 11.4C4.603 8.816 3.834 7.522 3.01 7.522c-.179 0-.806.378-1.881 1.132L0 7.197c1.185-1.044 2.351-2.084 3.501-3.128C5.08 2.701 6.266 1.984 7.055 1.91c1.867-.18 3.016 1.1 3.447 3.838.465 2.953.789 4.789.971 5.507.539 2.45 1.131 3.674 1.776 3.674.502 0 1.256-.796 2.265-2.385 1.004-1.589 1.54-2.797 1.612-3.628.144-1.371-.395-2.061-1.614-2.061-.574 0-1.167.121-1.777.391 1.186-3.868 3.434-5.757 6.762-5.637 2.473.06 3.628 1.664 3.493 4.797l-.013.01z"
      />
    </svg>
  ),
  PlatformYouTube: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"
      />
    </svg>
  ),
  Previous: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (12 / 21)}
      height={size}
      viewBox="0 0 12 21"
    >
      <g fill={color} fillRule="evenodd">
        <path d="M1.117 10.183l10.366 9.7V.483z" />
        <path d="M.5 20.5V.5h3v20z" />
      </g>
    </svg>
  ),
  Pricing: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 512 512"
    >
      <path
        fill={color}
        d="M240 32c-132.548 0-240 107.452-240 240s107.452 240 240 240c132.549 0 240-107.451 240-240s-107.451-240-240-240zM240 464c-106.039 0-192-85.961-192-192s85.961-192 192-192c106.037 0 192 85.961 192 192s-85.963 192-192 192z"
      />
      <path
        fill={color}
        d="M304 352h-112v-64h48c8.836 0 16-7.163 16-16s-7.164-16-16-16h-48v-16c0-26.467 21.533-48 48-48 17.085 0 33.021 9.202 41.59 24.015 4.425 7.649 14.213 10.263 21.861 5.838 7.648-4.424 10.263-14.212 5.838-21.861-14.269-24.668-40.819-39.992-69.289-39.992-44.112 0-80 35.888-80 80v16h-16c-8.836 0-16 7.163-16 16s7.164 16 16 16h16v96h144c8.837 0 16-7.163 16-16s-7.163-16-16-16z"
      />
    </svg>
  ),
  Refresh: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 27)}
      height={size}
      viewBox="0 0 24 27"
    >
      <g fill="none" fillRule="evenodd">
        <path
          stroke="#FFF"
          strokeWidth="4"
          d="M12 4.31c5.523 0 10 4.632 10 10.345C22 20.368 17.523 25 12 25S2 20.368 2 14.655"
        />
        <path fill="#FFF" d="M6.052 4.31L12.948.144v8.333z" />
      </g>
    </svg>
  ),
  Search: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (28 / 27)}
      height={size}
      viewBox="0 0 28 27"
    >
      <g fill="none" fillRule="evenodd" transform="translate(2 2)">
        <g strokeLinecap="round" strokeLinejoin="round" transform="rotate(-135 20.118 19.42)">
          <path fill={color} d="M14.38 18.919h11.476v1H14.38z" />
          <path stroke={color} d="M13.88 18.419h12.476v2H13.88z" />
        </g>
        <ellipse cx="8.386" cy="8.445" stroke={color} strokeWidth="3" rx="8.386" ry="8.445" />
      </g>
    </svg>
  ),
  SignIn: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 29 29"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="2" transform="translate(1 1)">
        <path d="M18.91 13.002c0 2.96-2.409 5.36-5.38 5.36-2.97 0-5.38-2.4-5.38-5.36 0-2.96 2.41-5.36 5.38-5.36 2.971 0 5.38 2.4 5.38 5.36z" />
        <path d="M5.094 23.96c0-3.104 3.764-5.62 8.406-5.62 4.642 0 8.406 2.516 8.406 5.62" />
        <ellipse cx="13.5" cy="13.5" rx="13.5" ry="13.5" />
      </g>
    </svg>
  ),
  Sort: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
    >
      <path fill={color} d="M6 4v11h-2v-11h-2.5l3.5-3.5 3.5 3.5zM10 12v-11h2v11h2.5l-3.5 3.5-3.5-3.5z" />
    </svg>
  ),
  Spotify: ({ className, size = DEFAULT_SIZE, color = colorSpotify.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"
      />
    </svg>
  ),
  ThemeAutoAndVehicles: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 13)}
      height={size}
      viewBox="0 0 24 13"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path d="M6 7.75A2.259 2.259 0 0 0 3.75 10 2.259 2.259 0 0 0 6 12.25c.95 0 1.796-.608 2.116-1.498A2.21 2.21 0 0 0 8.25 10 2.259 2.259 0 0 0 6 7.75zM18 7.75A2.259 2.259 0 0 0 15.75 10 2.259 2.259 0 0 0 18 12.25c.95 0 1.796-.608 2.116-1.498A2.21 2.21 0 0 0 20.25 10 2.259 2.259 0 0 0 18 7.75z" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.531 10.349L1 10.051V6.298l5.77-1.96L9.657 1.31l7.076.049L20.16 4.42H23v4.587l-2.253.897"
        />
      </g>
    </svg>
  ),
  ThemeBeautyAndFashion: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (20 / 18)}
      height={size}
      viewBox="0 0 20 18"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.005 12.624L5.36 1.214A.506.506 0 0 0 4.947 1C2.587 1 1 2.826 1 5.546c0 1.067.377 2.103 1.061 2.918l.009.007c.18.235.277.516.277.814l.391 7.035c0 .28.227.506.507.506h1.313c.28 0 .506-.226.506-.506l.388-8.316C6 8.411 6.905 9.427 7.841 11.95c1.754 4.74 3.633 4.877 3.842 4.877h4.041c1.022 0 2.779-.443 2.779-1.465 0-.524-.748-1.247-1.207-1.384-1.922-.572-1.922-.572-3.291-1.354z"
      />
    </svg>
  ),
  ThemeComedy: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 21"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M16 11.02c-.413 2.798-2.9 4.977-5.995 4.98C6.906 16 4.414 13.8 4 11"
        />
        <path
          fill="#FFF"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M6.502 6c.28 0 .498.223.498.502 0 .28-.22.498-.498.498a.5.5 0 1 1 0-1zM13.502 6c.28 0 .498.223.498.502 0 .28-.22.498-.498.498a.5.5 0 1 1 0-1z"
        />
        <path d="M10.125.75C4.956.75.75 4.956.75 10.125S4.956 19.5 10.125 19.5s9.375-4.206 9.375-9.375S15.294.75 10.125.75z" />
      </g>
    </svg>
  ),
  ThemeEducation: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 19)}
      height={size}
      viewBox="0 0 24 19"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 11L1 6.26 12 1l11 5.26z" />
        <path d="M18.25 8.84l-12.5-.085v7.038c3.576 3.37 9.251 3.257 12.5-.242V8.84z" />
      </g>
    </svg>
  ),
  ThemeEntertainment: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 21"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12.016c-.344 2.238-2.416 3.981-4.996 3.984-2.582 0-4.66-1.76-5.004-4l10 .016z"
        />
        <path d="M10.125.75C4.956.75.75 4.956.75 10.125S4.956 19.5 10.125 19.5s9.375-4.206 9.375-9.375S15.294.75 10.125.75z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M5 9l2-1.5L5 6M15 9l-2-1.5L15 6" />
      </g>
    </svg>
  ),
  ThemeFilmAndAnimation: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path d="M10 .75C4.9.75.75 4.9.75 10S4.9 19.25 10 19.25s9.25-4.15 9.25-9.25S15.1.75 10 .75z" />
        <path d="M10 .75C4.9.75.75 4.9.75 10S4.9 19.25 10 19.25s9.25-4.15 9.25-9.25S15.1.75 10 .75z" />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M10 3c1.114 0 2 .886 2 2 0 1.114-.886 2-2 2-1.114 0-2-.886-2-2 0-1.114.885-2 2-2zM10 17c-1.114 0-2-.886-2-2 0-1.114.886-2 2-2 1.114 0 2 .886 2 2 0 1.114-.914 2-2 2zM15 8c1.114 0 2 .886 2 2 0 1.114-.886 2-2 2-1.114 0-2-.886-2-2 0-1.114.886-2 2-2zM5 8c1.114 0 2 .886 2 2 0 1.114-.886 2-2 2-1.114 0-2-.886-2-2 0-1.114.914-2 2-2zM12.494 19h6.027"
        />
      </g>
    </svg>
  ),
  ThemeFood: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 14)}
      height={size}
      viewBox="0 0 24 14"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="M3 13a9 9 0 0 1 18 0M1.494 13h21.012" />
        <path d="M11 4V2.2c0-.66.45-1.2 1-1.2s1 .54 1 1.2V4" />
      </g>
    </svg>
  ),
  ThemeGaming: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 17)}
      height={size}
      viewBox="0 0 24 17"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="M22.7 7.61c-.874-4.076-3.406-7.062-5.817-6.554-.958.203-1.728.926-2.238 2.024-.06.128-.112.292-.163.491l-.044.184h-4.88a3.468 3.468 0 0 0-.194-.651c-.432-1.085-1.256-1.838-2.247-2.048C4.706.548 2.174 3.534 1.299 7.61c-.874 4.077.215 7.825 2.627 8.334 1.823.384 3.747-1.23 4.958-3.91.077-.192.269-.488.611-.79.588-.517 1.403-.83 2.505-.83 1.102 0 1.917.313 2.505.83.342.302.534.598.604.772 1.218 2.699 3.142 4.312 4.965 3.928 2.412-.509 3.5-4.257 2.627-8.334z" />
        <path d="M9 6.5c0 .667-1 .667-1 0s1-.667 1 0M16 6.5c0 .667-1 .667-1 0s1-.667 1 0M17.25 9.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0zM4.25 9.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0z" />
      </g>
    </svg>
  ),
  ThemeHowToAndStyle: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 14)}
      height={size}
      viewBox="0 -3.5 24 14"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.2">
        <path d="M23.199 5.286c-.697.76-3.15 1.114-6.436 1.114C14.7 6.4 12.6 5.022 12.6 3.5c0-1.745 1.192-2.9 2.96-2.9.66 0 1.644.607 3.837 2.26l.034.025c1.92 1.446 2.937 2.142 3.768 2.401zM.801 5.286c.697.76 3.15 1.114 6.436 1.114C9.3 6.4 11.4 5.022 11.4 3.5c0-1.745-1.192-2.9-2.96-2.9-.66 0-1.644.607-3.837 2.26l-.034.025C2.649 4.33 1.632 5.027.8 5.286z" />
      </g>
    </svg>
  ),
  ThemeMusic: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 21 21"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="M7.265 17c0 1.657-1.357 3-3.031 3-1.674 0-3.032-1.343-3.032-3s1.358-3 3.032-3 3.031 1.343 3.031 3zM19.265 14.1c0 1.712-1.402 3.1-3.132 3.1-1.73 0-3.133-1.388-3.133-3.1 0-1.712 1.403-3.1 3.133-3.1s3.132 1.388 3.132 3.1z" />
        <path d="M7.32 17.087l.023-11.571L19.229 1.11l.066 12.82" />
      </g>
    </svg>
  ),
  ThemePetsAndAnimals: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (24 / 22)}
      height={size}
      viewBox="0 0 24 22"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path d="M11.857 10.75c-2.185 0-3.512 1.374-6.34 6.136-.62 1.047-.804 2.003-.398 2.738.542.976 2.158 1.626 4.348 1.626h5.413c2.143 0 3.7-.622 4.189-1.543.352-.662.198-1.638-.527-2.771-3.011-4.717-4.492-6.186-6.685-6.186zM8.54 7.16l.045-.001c.012 0 .007 0 .058-.005.676-.036 1.308-.415 1.738-1.058.413-.618.616-1.424.563-2.267C10.833 2.024 9.59.677 8.234.753c-.676.037-1.308.415-1.738 1.058-.413.619-.616 1.425-.563 2.267.11 1.753 1.287 3.081 2.607 3.081zM15.164 7.16c1.321 0 2.498-1.328 2.606-3.082.113-1.829-.928-3.254-2.3-3.325C14.118.68 12.87 2.029 12.758 3.83c-.113 1.829.927 3.254 2.292 3.325.066.003.086.003.114.003zM4.114 12.16c.5 0 .938-.15 1.285-.43.959-.771.94-2.435-.152-3.715-.68-.796-1.626-1.265-2.51-1.265-.5 0-.94.149-1.284.427-.471.379-.73.987-.7 1.686.03.694.33 1.418.851 2.03.68.797 1.626 1.266 2.51 1.266zM19.732 12.16c.885 0 1.833-.471 2.515-1.27 1.093-1.279 1.11-2.943.153-3.714-.348-.278-.79-.426-1.289-.426-.885 0-1.834.47-2.514 1.267-1.094 1.28-1.112 2.943-.153 3.715.347.279.788.427 1.288.427z" />
      </g>
    </svg>
  ),
  ThemeScienceAndTechnology: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path d="M21.08 3.92c-1.014-1.015-6.013 1.71-10.731 6.429-4.719 4.718-7.444 9.717-6.43 10.732 1.015 1.014 6.014-1.711 10.732-6.43 4.718-4.717 7.444-9.717 6.43-10.732z" />
        <path d="M21.08 21.08c1.015-1.014-1.71-6.013-6.429-10.731C9.933 5.63 4.934 2.905 3.92 3.919 2.905 4.935 5.63 9.934 10.35 14.652c4.718 4.718 9.717 7.444 10.732 6.43z" />
        <path d="M23.25 12.5c0-1.272-5.069-2.75-11.25-2.75S.75 11.228.75 12.5 5.819 15.25 12 15.25s11.25-1.478 11.25-2.75z" />
        <path d="M12.5 23.25c1.272 0 2.75-5.069 2.75-11.25S13.772.75 12.5.75 9.75 5.819 9.75 12s1.478 11.25 2.75 11.25z" />
      </g>
    </svg>
  ),
  ThemeSport: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeWidth="1.5">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M4 17c2.333-.964 4-3.51 4-6.5S6.333 4.964 4 4M16 17c-2.333-.964-4-3.51-4-6.5s1.667-5.536 4-6.5M10 1.493v17.014M1 10h17.507"
        />
        <path d="M10 .75C4.9.75.75 4.9.75 10S4.9 19.25 10 19.25s9.25-4.15 9.25-9.25S15.1.75 10 .75z" />
      </g>
    </svg>
  ),
  ThemeTravelAndEvents: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (16 / 24)}
      height={size}
      viewBox="0 0 16 24"
    >
      <g fill="none" fillRule="evenodd" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
        <path d="M12.114 21H3.886C2.3 21 1 19.904 1 18.565v-9.13C1 8.094 2.299 7 3.886 7h8.228C13.701 7 15 8.095 15 9.434v9.131C15 19.905 13.701 21 12.114 21zM5 21v1.294c0 .388-.278.706-.619.706H3.62c-.34 0-.619-.318-.619-.706V21M13 21v1.294c0 .388-.278.706-.618.706h-.763c-.34 0-.619-.318-.619-.706V21M4 7V1.48c0-.266.314-.48.701-.48H11.3c.387 0 .701.214.701.48V7M4 7v14M12 7v14" />
      </g>
    </svg>
  ),
  ThemeVlogs: ({ className, size = DEFAULT_SIZE, color = colorWhite.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
    >
      <path
        fill={color}
        d="M15.294 4.004c-0.165 0-0.335 0.058-0.491 0.168l-2.803 1.978v-1.651c0-0.825-0.675-1.5-1.5-1.5h-9c-0.825 0-1.5 0.675-1.5 1.5v7c0 0.825 0.675 1.5 1.5 1.5h9c0.825 0 1.5-0.675 1.5-1.5v-1.65l2.803 1.978c0.156 0.11 0.326 0.168 0.491 0.168 0 0 0 0 0 0 0.22 0 0.421-0.101 0.551-0.278 0.101-0.137 0.154-0.313 0.154-0.51v-6.415c-0-0.518-0.355-0.788-0.706-0.788zM15 10.743l-2.469-1.743h-1.531v2.5c0 0.271-0.229 0.5-0.5 0.5h-9c-0.271 0-0.5-0.229-0.5-0.5v-7c0-0.271 0.229-0.5 0.5-0.5h9c0.271 0 0.5 0.229 0.5 0.5v2.5h1.531l2.469-1.743v5.486z"
      />
      <path fill={color} d="M4 5l5 3-5 3z" />
    </svg>
  ),
  Twitter: ({ className, size = DEFAULT_SIZE, color = colorTwitter.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M32 7.075c-1.175 0.525-2.444 0.875-3.769 1.031 1.356-0.813 2.394-2.1 2.887-3.631-1.269 0.75-2.675 1.3-4.169 1.594-1.2-1.275-2.906-2.069-4.794-2.069-3.625 0-6.563 2.938-6.563 6.563 0 0.512 0.056 1.012 0.169 1.494-5.456-0.275-10.294-2.888-13.531-6.862-0.563 0.969-0.887 2.1-0.887 3.3 0 2.275 1.156 4.287 2.919 5.463-1.075-0.031-2.087-0.331-2.975-0.819 0 0.025 0 0.056 0 0.081 0 3.181 2.263 5.838 5.269 6.437-0.55 0.15-1.131 0.231-1.731 0.231-0.425 0-0.831-0.044-1.237-0.119 0.838 2.606 3.263 4.506 6.131 4.563-2.25 1.762-5.075 2.813-8.156 2.813-0.531 0-1.050-0.031-1.569-0.094 2.913 1.869 6.362 2.95 10.069 2.95 12.075 0 18.681-10.006 18.681-18.681 0-0.287-0.006-0.569-0.019-0.85 1.281-0.919 2.394-2.075 3.275-3.394z"
      />
    </svg>
  ),
  Visa: ({ className, size = DEFAULT_SIZE, color = '#142787' }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
    >
      <path
        fill={color}
        d="M23.26 11.494c-0.514-0.194-1.32-0.4-2.32-0.4-2.56 0-4.366 1.29-4.38 3.14-0.016 1.36 1.286 2.124 2.268 2.58 1.010 0.466 1.348 0.76 1.344 1.18-0.006 0.636-0.806 0.926-1.55 0.926-1.020 0-1.58-0.144-2.44-0.5l-0.32-0.15-0.36 2.13c0.62 0.26 1.74 0.484 2.9 0.5 2.72 0 4.5-1.28 4.52-3.252 0.020-1.084-0.68-1.906-2.16-2.584-0.9-0.44-1.46-0.734-1.46-1.18 0-0.394 0.48-0.816 1.48-0.816 0.86-0.014 1.46 0.172 1.94 0.364l0.24 0.108 0.36-2.060zM29.904 11.268h-2c-0.624 0-1.088 0.17-1.36 0.788l-3.848 8.712h2.72l0.546-1.428 3.32 0.004c0.080 0.332 0.32 1.424 0.32 1.424h2.398l-2.096-9.5zM12.88 11.188h2.592l-1.62 9.504h-2.592l1.62-9.506zM6.294 16.428l0.27 1.32 2.536-6.48h2.744l-4.080 9.486h-2.74l-2.24-8.034c-0.046-0.136-0.104-0.23-0.24-0.316-0.756-0.396-1.604-0.72-2.544-0.944l0.034-0.2h4.176c0.564 0.020 1.020 0.2 1.176 0.804l0.908 4.366zM26.708 17.396l1.032-2.66c-0.014 0.028 0.214-0.548 0.344-0.906l0.176 0.82 0.6 2.744h-2.152z"
      />
    </svg>
  ),
  Volume: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size * (35 / 32)}
      height={size}
      viewBox="0 0 35 32"
    >
      <g fill="none" fillRule="evenodd">
        <g stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2">
          <path d="M15.972 22.627c2.706-.89 4.668-3.528 4.668-6.645 0-3.118-1.962-5.756-4.668-6.646" />
          <path d="M19.267 27.477C23.72 26.014 26.8 21.11 26.8 15.982c0-5.128-3.228-9.469-7.68-10.932" />
          <path d="M24.047 30.99c5.272-1.93 9.08-8.246 9.08-15.008 0-6.762-3.73-12.919-9.002-14.848" />
        </g>
        <g fill={color}>
          <path d="M.494 16.207L8.34 24.32V8.093" />
          <path d="M0 11.432h5.25v9.127H0z" />
        </g>
      </g>
    </svg>
  ),
  Warning: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      fill={color}
      viewBox="0 0 24 24"
    >
      <path id="a" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  ),
  YouTube: ({ className, size = DEFAULT_SIZE, color = colorYouTube.toString() }) => (
    <svg
      className={classes(styles.container, className)}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={color}
        d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"
      />
    </svg>
  ),
  YouTubeCertified: ({ className, size = DEFAULT_SIZE, color = DEFAULT_COLOR }) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size * (388.812 / 219.054)}
      height={size}
      viewBox="809.547 213.306 388.812 219.054"
    >
      <path fill={colorWhite.toString()} d="M979.902 223.96V350.74h204.253V223.96H979.902z" />
      <g transform="translate(249.856 -264.397)">
        <path
          fill={colorWhite.toString()}
          stroke={colorWhite.toString()}
          strokeMiterlimit="10"
          d="M629.37 604.478c-6.388-.776-12.253-4.533-15.08-9.658-2.88-5.225-3.144-7.962-2.974-30.966.13-17.82.178-18.938.883-21.488 1.683-6.084 4.943-10.233 10.004-12.733 6.946-3.432 14.432-2.984 20.985 1.256 4.17 2.698 6.706 6.6 8.06 12.406.6 2.572.656 4.54.656 22.538 0 21.883-.105 23.147-2.347 27.888-2.16 4.57-7.04 8.595-12.133 10.007-2.24.618-6.136.982-8.058.748zm5.595-14.29c2.445-1.867 2.463-2.02 2.598-23.103.105-16.373.047-19.156-.45-21.39-.67-3.01-1.845-4.448-4.14-5.066-2.97-.8-5.693.9-6.636 4.145-.726 2.5-.718 39.643.01 42.146.544 1.877 2.31 3.933 3.624 4.212 1.703.364 3.796-.033 4.995-.945zm35.958 14.306c-3.54-.472-5.606-1.838-7.024-4.645-1.78-3.525-1.78-3.504-1.78-38.594v-32.75h14.282l.152 30.184c.163 32.794.114 32.027 2.077 32.52 1.804.454 3.796-.513 6.283-3.043l2.383-2.427.09-28.618.09-28.616 7.13-.096 7.134-.096v74.969l-.97.2c-1.168.24-11.982.224-12.854-.02-.53-.148-.615-.635-.615-3.57v-3.4l-2.024 1.972c-4.662 4.537-9.69 6.65-14.353 6.03zm-92.66-1.225c-.3-.486-.255-29.458.052-33.563.393-5.262.113-9.398-3.664-19.98-1.226-3.434-3.59-10.393-5.067-15.092-10.674-33.956-9.957-31.66-8.938-31.67 7.033-.06 15.113-.017 15.207.078.068.066 2.354 8.358 5.08 18.426 2.727 10.066 5.003 18.446 5.058 18.62.056.177 1.655-5.687 3.556-13.028 3.986-15.39 6.223-23.888 6.31-23.966.177-.163 2.16-.2 8.638-.163l7.17.04-.16 1.145c-.127.936-5.02 17.366-10.143 34.07-.563 1.84-1.99 6.595-3.17 10.564-1.18 3.972-2.61 8.688-3.18 10.48l-1.032 3.263v20.398c0 19.125-.04 20.407-.617 20.565-1.285.354-14.87.18-15.098-.19z"
        />
        <path
          fill={colorWhite.toString()}
          d="M629.533 603.44c-6.387-.775-12.252-4.532-15.077-9.657-2.882-5.226-3.146-7.96-2.976-30.967.13-17.82.178-18.937.885-21.488 1.683-6.083 4.943-10.23 10.004-12.732 6.944-3.432 14.43-2.984 20.983 1.255 4.173 2.7 6.708 6.604 8.06 12.41.6 2.57.657 4.537.657 22.537 0 21.88-.105 23.146-2.346 27.888-2.158 4.567-7.04 8.593-12.132 10.004-2.24.62-6.137.984-8.06.75zm5.596-14.29c2.444-1.867 2.462-2.02 2.598-23.103.104-16.373.047-19.155-.45-21.39-.67-3.01-1.845-4.448-4.14-5.065-2.972-.8-5.693.9-6.636 4.146-.727 2.5-.72 39.643.008 42.146.545 1.875 2.314 3.93 3.625 4.21 1.703.365 3.797-.03 4.994-.945zm35.958 14.306c-3.54-.47-5.607-1.838-7.025-4.645-1.78-3.522-1.78-3.502-1.78-38.593v-32.75h14.282l.153 30.186c.164 32.793.114 32.027 2.078 32.52 1.802.453 3.795-.513 6.28-3.045l2.384-2.426.09-28.616.09-28.618 7.132-.095 7.132-.096v74.969l-.97.198c-1.167.24-11.98.224-12.853-.02-.53-.147-.615-.633-.615-3.57v-3.398l-2.025 1.972c-4.66 4.537-9.69 6.65-14.352 6.028zm-92.662-1.226c-.3-.483-.254-29.456.053-33.56.392-5.262-.49-9.4-4.27-19.98-1.226-3.435-3.438-10.09-4.916-14.79-10.675-33.956-10.108-31.962-9.09-31.97 7.033-.06 15.718-.02 15.813.076.067.066 2.354 8.358 5.08 18.426 2.726 10.066 5.003 18.447 5.058 18.623.054.174 1.654-5.688 3.557-13.032 3.984-15.39 6.22-23.886 6.307-23.964.18-.165 2.16-.202 8.638-.166l7.17.042-.158 1.144c-.13.936-5.02 17.366-10.145 34.07-.564 1.84-1.99 6.595-3.17 10.566-1.18 3.97-2.61 8.687-3.18 10.48l-1.033 3.26v20.4c0 19.126-.038 20.406-.615 20.564-1.29.354-14.872.182-15.1-.19z"
        />
        <path
          fill={colorYouTube.toString()}
          d="M806.625 632.61c-8.232-.146-17.98-.375-21.658-.507-24.71-.89-41.675-1.84-45.064-2.523-4.83-.977-10.23-4.247-13.363-8.094-5.023-6.165-7.698-13.646-8.997-25.16-3.02-26.77-2.953-57.98.18-83.812 1.372-11.314 4.786-19.493 10.517-25.198 3.27-3.253 6.413-5.076 10.604-6.147 9.067-2.32 80.064-4.167 123.247-3.207 24.945.554 51.9 1.704 59.063 2.518 9.265 1.054 15.77 5.854 20.27 14.953 3.4 6.87 4.494 12.22 5.87 28.7 1.088 13.06 1.348 21.187 1.153 36.254-.232 18.03-1.378 33.912-3.092 42.828-1.812 9.426-6.098 17.463-11.633 21.812-4.275 3.36-8.828 4.858-15.987 5.263-2.13.12-4.825.293-5.987.382-4.134.32-26.253 1.217-38.385 1.557-18.035.504-49.58.684-66.735.38z"
        />
        <path
          fill={colorWhite.toString()}
          stroke={colorWhite.toString()}
          strokeWidth=".352"
          d="M736.85 502.98v13.372l7.836.1 7.835.1.09 42.434c.048 23.34.16 42.63.253 42.875.13.348 1.762.428 7.142.354l6.956-.09.176-42.786.177-42.786 8.022-.1 8.022-.1-.1-6.593-.1-6.592-23.153-.1-23.153-.09zm100.718.01v99.31h12.678v-3.345c0-2.218.137-3.346.396-3.346.215 0 1.64 1.168 3.17 2.607 4.93 4.64 9.2 5.92 14.526 4.347 2.04-.602 4.53-3.037 5.645-5.524 2.144-4.775 2.146-4.888 2.146-31.716 0-22.024-.054-24.74-.606-27.116-1.77-7.62-5.633-10.956-12.117-10.466-3.635.275-6.498 1.722-9.926 5.03-1.487 1.436-2.824 2.617-2.97 2.617-.146 0-.265-7.29-.265-16.2v-16.2h-12.677zm69.772 24.675c-2.062.042-4.128.412-6.107 1.135-6.828 2.49-10.864 6.977-12.49 13.91-.575 2.45-.638 4.653-.638 22.614 0 22.03.08 22.928 2.33 27.435 4.014 8.03 14.067 12.218 23.2 9.662 6.783-1.898 11.477-6.527 13.24-13.063.3-1.117.635-4.284.747-7.044l.21-5.02H914.78l-.166 4.49c-.182 5.116-.705 6.868-2.563 8.497-1.98 1.74-5.62 1.86-7.987.264-2.816-1.896-3.52-5.105-3.38-15.54l.1-7.394 13.514-.1 13.515-.088-.188-11.005c-.207-12.27-.464-14.134-2.53-18.488-3.068-6.453-10.383-10.418-17.754-10.267zm-120.836 1.033v31.883c0 34.72.038 35.467 1.982 38.816 2.124 3.657 7.11 4.803 12.358 2.838 2.534-.95 5.505-3 8.012-5.546 1.155-1.175 2.304-2.136 2.553-2.136.34 0 .45.96.45 3.874v3.873h12.678v-73.603H811.86v56.777l-2.73 2.718c-2.165 2.154-3.076 2.803-4.412 3.17-2.27.622-3.696.195-4.632-1.398-.707-1.203-.722-1.742-.814-31.244l-.1-30.02h-12.668zm121.352 10.435c2.83 0 4.613 1.09 5.822 3.544.767 1.556.85 2.21.96 7.944l.107 6.253h-6.9c-5.95 0-6.937-.086-7.12-.562-.326-.85.13-10.723.56-12.16 1.018-3.376 3.174-5.017 6.57-5.017zm-50.754.825c1.99-.07 3.702.843 4.622 2.695.64 1.292.685 2.45.758 22.143.073 18.894.025 20.933-.527 22.526-.424 1.225-.97 1.995-1.805 2.554-2.11 1.412-5.178.962-7.968-1.166l-1.232-.936v-44.91l1.232-.937c1.655-1.26 3.373-1.914 4.92-1.97z"
        />
      </g>
      <g fill={colorWhite.toString()}>
        <path d="M838.915 389.48c-5.1 0-9.125 1.698-12.076 5.095-2.952 3.396-4.43 8.046-4.43 13.948 0 6.073 1.424 10.766 4.27 14.076 2.846 3.31 6.903 4.966 12.172 4.966 3.237 0 6.93-.58 11.077-1.745v4.73c-3.218 1.205-7.185 1.81-11.903 1.81-6.834 0-12.107-2.074-15.822-6.222-3.713-4.146-5.57-10.04-5.57-17.678 0-4.782.895-8.972 2.684-12.568 1.786-3.598 4.367-6.37 7.743-8.316 3.374-1.946 7.347-2.92 11.917-2.92 4.866 0 9.12.89 12.76 2.666l-2.286 4.635c-3.515-1.65-7.028-2.477-10.54-2.477zM895.02 431.725h-25.867v-46.4h25.866v4.79h-20.473v14.95h19.234v4.76h-19.233V426.9h20.472v4.825zM919.797 412.428v19.297h-5.395v-46.4h12.727c5.69 0 9.895 1.09 12.615 3.268 2.718 2.18 4.078 5.46 4.078 9.84 0 6.136-3.11 10.283-9.33 12.44l12.6 20.853h-6.38l-11.235-19.297h-9.68zm0-4.634h7.396c3.81 0 6.602-.756 8.38-2.27 1.776-1.513 2.665-3.78 2.665-6.808 0-3.067-.904-5.28-2.714-6.633-1.81-1.354-4.713-2.03-8.712-2.03h-7.015v17.74zM977.965 431.725h-5.396v-41.61h-14.695v-4.79h34.785v4.79h-14.694v41.61zM1008.742 431.725v-46.4h5.396v46.4h-5.396zM1041.36 431.725h-5.396v-46.4h25.867v4.79h-20.47v16.98h19.232v4.794h-19.233v19.835zM1078.612 431.725v-46.4h5.396v46.4h-5.396zM1131.702 431.725h-25.867v-46.4h25.867v4.79h-20.472v14.95h19.233v4.76h-19.233V426.9h20.472v4.825zM1188.123 408.08c0 7.66-2.08 13.515-6.236 17.566-4.158 4.053-10.14 6.078-17.948 6.078h-12.855v-46.4h14.22c7.214 0 12.82 1.998 16.82 5.998 4 3.998 5.998 9.584 5.998 16.758zm-5.713.19c0-6.05-1.52-10.61-4.555-13.68-3.036-3.066-7.548-4.602-13.536-4.602h-7.84v37.07h6.57c6.432 0 11.267-1.58 14.504-4.744s4.856-7.844 4.856-14.044z" />
      </g>
    </svg>
  ),
};

const styles = {
  container: style({
    position: 'relative',
  }),
};

export const ThemeMap: { [key: string]: any } = {
  'auto-vehicles': SVGIcon.ThemeAutoAndVehicles,
  'autos-vehicles': SVGIcon.ThemeAutoAndVehicles,
  'beauty-fashion': SVGIcon.ThemeBeautyAndFashion,
  comedy: SVGIcon.ThemeComedy,
  education: SVGIcon.ThemeEducation,
  entertainment: SVGIcon.ThemeEntertainment,
  'film-animation': SVGIcon.ThemeFilmAndAnimation,
  food: SVGIcon.ThemeFood,
  gaming: SVGIcon.ThemeGaming,
  'howto-style': SVGIcon.ThemeHowToAndStyle,
  music: SVGIcon.ThemeMusic,
  'pets-animals': SVGIcon.ThemePetsAndAnimals,
  'science-technology': SVGIcon.ThemeScienceAndTechnology,
  sport: SVGIcon.ThemeSport,
  'travel-events': SVGIcon.ThemeTravelAndEvents,
  vlogs: SVGIcon.ThemeVlogs,
};

export const GenreMap: { [key: string]: any } = {
  breakbeat: SVGIcon.GenreBreakbeat,
  'drum-bass': SVGIcon.GenreDrumAndBass,
  dubstep: SVGIcon.GenreDubstep,
  electronic: SVGIcon.GenreElectronic,
  folk: SVGIcon.GenreFolk,
  'hip-hop': SVGIcon.GenreHipHop,
  house: SVGIcon.GenreHouse,
  indie: SVGIcon.GenreIndie,
  pop: SVGIcon.GenrePop,
  punk: SVGIcon.GenrePunk,
  remixes: SVGIcon.GenreRemixes,
  rock: SVGIcon.GenreRock,
};

export const VideoPlatformMap: { [key: string]: any } = {
  dailymotion: SVGIcon.PlatformDailymotion,
  facebook: SVGIcon.PlatformFacebook,
  instagram: SVGIcon.PlatformInstagram,
  linkedin: SVGIcon.PlatformLinkedIn,
  snapchat: SVGIcon.PlatformSnapchat,
  twitch: SVGIcon.PlatformTwitch,
  twitter: SVGIcon.PlatformTwitter,
  vimeo: SVGIcon.PlatformVimeo,
  youtube: SVGIcon.PlatformYouTube,
};

export interface SVGIconTypes {
  About: React.SFC<SVGIconProps>;
  ArrowDown: React.SFC<SVGIconProps>;
  ArrowLeft: React.SFC<SVGIconProps>;
  ArrowMore: React.SFC<SVGIconProps>;
  ArrowRight: React.SFC<SVGIconProps>;
  ArrowUpRightBox: React.SFC<SVGIconProps>;
  ArrowUpRightBoxThick: React.SFC<SVGIconProps>;
  Basket: React.SFC<SVGIconProps>;
  Book: React.SFC<SVGIconProps>;
  Browse: React.SFC<SVGIconProps>;
  Cross: React.SFC<SVGIconProps>;
  Checkmark: React.SFC<SVGIconProps>;
  CheckmarkCircle: React.SFC<SVGIconProps>;
  Copy: React.SFC<SVGIconProps>;
  Copyright: React.SFC<SVGIconProps>;
  Dropbox: React.SFC<SVGIconProps>;
  Facebook: React.SFC<SVGIconProps>;
  Fire: React.SFC<SVGIconProps>;
  FAQ: React.SFC<SVGIconProps>;
  Favourite: React.SFC<SVGIconProps>;
  FavouriteDesktopCTA: React.SFC<SVGIconProps>;
  FavouriteMobileCTA: React.SFC<SVGIconProps>;
  Filters: React.SFC<SVGIconProps>;
  GenreBreakbeat: React.SFC<SVGIconProps>;
  GenreDrumAndBass: React.SFC<SVGIconProps>;
  GenreDubstep: React.SFC<SVGIconProps>;
  GenreElectronic: React.SFC<SVGIconProps>;
  GenreFolk: React.SFC<SVGIconProps>;
  GenreHipHop: React.SFC<SVGIconProps>;
  GenreHouse: React.SFC<SVGIconProps>;
  GenreIndie: React.SFC<SVGIconProps>;
  GenrePop: React.SFC<SVGIconProps>;
  GenrePunk: React.SFC<SVGIconProps>;
  GenreRemixes: React.SFC<SVGIconProps>;
  GenreRock: React.SFC<SVGIconProps>;
  Google: React.SFC<SVGIconProps>;
  GoogleMultiColour: React.SFC<SVGIconProps>;
  HookIt: React.SFC<SVGIconProps>;
  InfoCircle: React.SFC<SVGIconProps>;
  Instagram: React.SFC<SVGIconProps>;
  LinkedIn: React.SFC<SVGIconProps>;
  MasterCard: React.SFC<SVGIconProps>;
  Menu: React.SFC<SVGIconProps>;
  Next: React.SFC<SVGIconProps>;
  NewTab: React.SFC<SVGIconProps>;
  Pause: React.SFC<SVGIconProps>;
  Play: React.SFC<SVGIconProps>;
  PlatformDailymotion: React.SFC<SVGIconProps>;
  PlatformFacebook: React.SFC<SVGIconProps>;
  PlatformInstagram: React.SFC<SVGIconProps>;
  PlatformLinkedIn: React.SFC<SVGIconProps>;
  PlatformSnapchat: React.SFC<SVGIconProps>;
  PlatformTwitch: React.SFC<SVGIconProps>;
  PlatformTwitter: React.SFC<SVGIconProps>;
  PlatformVimeo: React.SFC<SVGIconProps>;
  PlatformYouTube: React.SFC<SVGIconProps>;
  Previous: React.SFC<SVGIconProps>;
  Pricing: React.SFC<SVGIconProps>;
  Refresh: React.SFC<SVGIconProps>;
  Search: React.SFC<SVGIconProps>;
  SignIn: React.SFC<SVGIconProps>;
  Sort: React.SFC<SVGIconProps>;
  Spotify: React.SFC<SVGIconProps>;
  ThemeAutoAndVehicles: React.SFC<SVGIconProps>;
  ThemeBeautyAndFashion: React.SFC<SVGIconProps>;
  ThemeComedy: React.SFC<SVGIconProps>;
  ThemeEducation: React.SFC<SVGIconProps>;
  ThemeEntertainment: React.SFC<SVGIconProps>;
  ThemeFilmAndAnimation: React.SFC<SVGIconProps>;
  ThemeFood: React.SFC<SVGIconProps>;
  ThemeGaming: React.SFC<SVGIconProps>;
  ThemeHowToAndStyle: React.SFC<SVGIconProps>;
  ThemeMusic: React.SFC<SVGIconProps>;
  ThemePetsAndAnimals: React.SFC<SVGIconProps>;
  ThemeScienceAndTechnology: React.SFC<SVGIconProps>;
  ThemeSport: React.SFC<SVGIconProps>;
  ThemeTravelAndEvents: React.SFC<SVGIconProps>;
  ThemeVlogs: React.SFC<SVGIconProps>;
  Twitter: React.SFC<SVGIconProps>;
  Visa: React.SFC<SVGIconProps>;
  Volume: React.SFC<SVGIconProps>;
  Warning: React.SFC<SVGIconProps>;
  YouTube: React.SFC<SVGIconProps>;
  YouTubeCertified: React.SFC<SVGIconProps>;
}
